/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {SectionIcon} from '../models/SectionIcon';

export interface GetConferenceIcons$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getConferenceIconsRequest = createAction<PayloadData<void>>('CONFERENCE_ICONS__GET_CONFERENCE_ICONS__REQUEST');
export const getConferenceIconsSuccess = createAction<PayloadData<Array<SectionIcon>>>('CONFERENCE_ICONS__GET_CONFERENCE_ICONS__SUCCESS');
export const getConferenceIconsFailure = createAction<PayloadData<Error, void, true>>('CONFERENCE_ICONS__GET_CONFERENCE_ICONS__FAILURE');

export const getConferenceIconsActions = [
    getConferenceIconsRequest,
    getConferenceIconsSuccess,
    getConferenceIconsFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getConferenceIcons = (config?: GetConferenceIcons$Config) => {
    return {
        CALL_API: {
            types: getConferenceIconsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/conferences/icons`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

